import { Typography } from '@mui/material';
import { getTimeForHours } from '../../../../../constants/stringUtilities';
import { TimesheetSiteLog } from '../../../../../constants/Timesheet/Timesheet';
import { SiteLogPicturesTooltip } from '../../SiteLogPicturesTooltip';

export type SiteLogCellProps = {
	siteLog: {
		logs: TimesheetSiteLog[] | null;
		formattedLogs: string[] | null;
	};
};

export const SiteLogCell = ({ siteLog }: SiteLogCellProps): JSX.Element => {
	const formattedLogs = siteLog.formattedLogs;
	const siteLogs = siteLog.logs;

	return formattedLogs && siteLogs ? (
		<>
			{siteLogs.map((log, index) => (
				<SiteLogPicturesTooltip
					key={'pictureTooltip' + index + log.id}
					signInURL={log.in.photoUrl ?? ''}
					signOutURL={log.out?.photoUrl ?? ''}>
					<Typography
						sx={{
							fontSize: 'small',
							textWrap: 'pretty',
							textDecoration: 'underline dotted',
							textAlign: { xs: 'right', md: 'center' },
						}}>
						{formattedLogs[index]}
					</Typography>
				</SiteLogPicturesTooltip>
			))}
		</>
	) : (
		<Typography
			data-testid="no-site-log"
			sx={{
				fontSize: 'small',
				textWrap: 'pretty',
				textAlign: { xs: 'right', md: 'center' },
			}}>
			{getTimeForHours(0)}
		</Typography>
	);
};
